// extracted by mini-css-extract-plugin
module.exports = {"border-bottom":"Deployment_border-bottom__k9SCy","deployment-action":"Deployment_deployment-action__rfehC","actions":"Deployment_actions__eOADX"};